export enum PromotionServiceId {
  Bump = 'bump',
  Vip = 'vip',
  Feature = 'feature',
  BalancePaidAd = 'balance_paid_ad',
  Deposit = 'deposit',
  Restore = 'restore',
  LimitPayment = 'limit_payment',
  Wallet = 'wallet',
  PayInvoice = 'pay_invoice'
}
